import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const useTermsOfService = () => {
  return useQuery({
    queryKey: ['termsOfService'],
    queryFn: async () => {
      const response = await api.get('/terms-of-service');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

